import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { LOGIN, CHECK_LOCAL_AUTH } from '../type';
import { history } from 'store';
import { loginSuccessAction, loginErrorAction } from '../action';
import { loadOrganisationDetailSuccessAction } from 'store/organisation/action';

import { authService, organisationService } from 'services';
import {
  setDataToLocalStorage,
  getDataFromLocalStorage,
} from 'services/local-storage';
import { StorageType } from 'common/enum';
import { setToken } from 'services/axios';

function* login() {
  while (1) {
    const action = yield take(LOGIN);
    try {
      const loginResponse = yield call(authService.login, action.payload);

      yield setDataToLocalStorage(StorageType.AuthInfo, loginResponse);
      yield setToken(loginResponse.token);

      const { companyId } = loginResponse;
      if (companyId) {
        const organisationDetail = yield call(
          organisationService.loadOrganisationDetail,
          { organisationId: companyId },
        );
        setDataToLocalStorage(
          StorageType.OrganisationDetail,
          organisationDetail,
        );
        yield put(loadOrganisationDetailSuccessAction(organisationDetail));
      }

      yield put(loginSuccessAction(loginResponse));

      history.push('/');
    } catch (err) {
      notification.error({
        message: 'Failed to login',
      });
      yield put(loginErrorAction(err));
    }
  }
}

function* checkLocalAuth() {
  while (1) {
    yield take(CHECK_LOCAL_AUTH);
    try {
      const auth = getDataFromLocalStorage(StorageType.AuthInfo);
      if (auth) {
        yield put(loginSuccessAction(auth));
      }
    } catch (err) {
      yield put(loginErrorAction(err));
    }
  }
}
export default function* rootSaga() {
  yield all([login(), checkLocalAuth()]);
}
